var localhost = 'localhost';
var development = {
  isProduction: false,
  port: process.env.PORT || 5000,
  apiPort: 3030,
  app: {
    name: 'f1-loki development'
  },
  CDN_SELF: '',
  // towards `f1-loki.herokuapp.com`
  API_URL_ASSET_CDN: 'https://asset.dekoruma.com',
  API_URL_BULLSEYE: 'https://us-central1-f1-bullseye.cloudfunctions.net/',
  API_URL_CHITAURI: "http://" + localhost + ":6900/api/v1",
  API_URL_DOOM: "http://" + localhost + ":8080/api/v1",
  API_URL_DORMAMMU: "http://" + localhost + ":8013/api/v1",
  API_URL_EGO: "http://" + localhost + ":8800/api/v1",
  API_URL_GALACTUS: "http://" + localhost + ":8002",
  API_URL_GOBLIN: "http://" + localhost + ":8000/api/v2",
  API_URL_HELA: "http://" + localhost + ":4200/api/v1",
  API_URL_IMGIX: 'http://f1-styx.imgix.net',
  API_URL_IMGIX_ALT: 'https://f1-styx.imgix.net',
  API_URL_IMGIX_PRIVATE: 'https://f1-styx.imgix.net',
  API_URL_IMGIX_PUBLIC: 'https://f1-styx.imgix.net',
  API_URL_KINGPIN: "http://" + localhost + ":9000/api/v1",
  API_URL_KLAW: "http://" + localhost + ":8011/api/v1",
  API_URL_MADTHINKER: "http://" + localhost + ":4000/api/v1",
  API_URL_MAXIMUS: "http://" + localhost + ":8024/api/v1",
  API_URL_MEDIA_CDN: 'https://media.dekoruma.com',
  API_URL_RONAN: "http://" + localhost + ":8040/api/v1",
  API_URL_SAURON: "http://" + localhost + ":1111/api/v1",
  API_URL_SIN: "http://" + localhost + ":1710/api/v1",
  API_URL_SURTUR: "http://" + localhost + ":8008/api/v1",
  API_URL_SURTUR_V2: "http://" + localhost + ":8008/api/v2",
  API_URL_TINKERER: "http://" + localhost + ":4000",
  API_URL_THANOS: "http://" + localhost + ":8002/api/v1",
  API_URL_VIPER: "http://" + localhost + ":8010/api/v1",
  API_URL_WORDPRESS: 'https://wp2-dekoruma.global.ssl.fastly.net/rest/v1.1/sites/dekoruma.wordpress.com',
  VIEW_URL_GOBLIN: "http://" + localhost + ":8000",
  ALGOLIA_APP_NAME: 'D2VY06YP2A',
  ALGOLIA_API_KEY: '5bbda829365ba015eb6fcec10cccdf72',
  ALGOLIA_3D_ASSET_INDEX_NAME: 'staging_3d_assets',
  ALGOLIA_3D_ASSET_MOST_DOWNLOADED_INDEX_NAME: 'staging_3d_assets_most_downloaded',
  ALGOLIA_3D_ASSET_RECENTLY_UPDATED_INDEX_NAME: 'staging_3d_assets_recently_updated',
  ALGOLIA_AREA_INDEX_NAME: 'master_locations',
  ALGOLIA_ARTICLE_SEARCH_INDEX_NAME: 'wp_searchable_posts',
  ALGOLIA_BANK_INDEX_NAME: 'staging_banks',
  ALGOLIA_COMPLAIN_INDEX_NAME: 'staging_complains',
  ALGOLIA_DEFAULT_INDEX_NAME: 'staging_products',
  ALGOLIA_DESIGNER_INDEX_NAME: 'staging_designers',
  ALGOLIA_HOTSPOT_INDEX_NAME: 'staging_hotspots',
  ALGOLIA_MOODBOARD_INDEX_NAME: 'staging_moodboards',
  ALGOLIA_PORTFOLIO_INDEX_NAME: 'staging_portfolios',
  ALGOLIA_PRODUCT_OPTION_VALUE_INDEX_NAME: 'staging_product_options',
  ALGOLIA_PRODUCT_REVIEW_INDEX_NAME: 'staging_product_reviews',
  ALGOLIA_PRODUCT_SUGGESTION_INDEX_NAME: 'query_suggestion_v2',
  ALGOLIA_PROJECT_INDEX_NAME: 'staging_projects',
  ALGOLIA_PROPERTY_SUGGESTION_INDEX_NAME: 'master_property_suggestions',
  ALGOLIA_PROPERTY_PRODUCTS_INDEX_NAME: 'master_property_products',
  ALGOLIA_REAL_ESTATE_INDEX_NAME: 'staging_real_estates',
  ALGOLIA_RESALE_UNIT_INDEX_NAME: 'master_secondary_unit_types',
  ALGOLIA_REVIEW_INDEX_NAME: 'staging_reviews',
  ALGOLIA_STOCK_RECORD_INDEX_NAME: 'staging_stockrecords',
  ALGOLIA_SUPPLY_WAREHOUSE_INDEX_NAME: 'supply_warehouse',
  ALGOLIA_UNIT_TYPE_INDEX_NAME: 'staging_unit_types',
  ALGOLIA_VOUCHER_INDEX_NAME: 'staging_vouchers',
  S3_SIGN_URL: 'http://f1-sign-y361678b056b7745.herokuapp.com/api/s3/sign',
  S3_BUCKET_PUBLIC_URL: 'https://f1-static.s3-ap-southeast-1.amazonaws.com',
  S3_BUCKET_PRIVATE_URL: 'https://s3-ap-southeast-1.amazonaws.com/f1-static',
  FACEBOOK_APP_ID: 1112371492108485,
  FB_CAPI_ACCESS_TOKEN: 'EAAKbK4BDxo0BAMZA8ZBAddxW8MbROQaSWq9RDlqa8bNQZBBBa06JK4QJikRSfskevRAHctUyPVQvMzdHb7vhVo5THtnIZAUgtwo4HZCJcS2DRiE5CPdiEQiQLLOMnDjvV2RaBtGjWt1GukAFaJC6AQYcLnS6OwXsLcnvS1QpJXpHIU2jgZAIq7SsmoTcDnT7gZD',
  FACEBOOK_SDK_URL: 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.4&appId=1112371492108485',
  MIDTRANS_CLIENT_KEY: 'VT-client-PqMaHzXbAATAVEWX',
  MIDTRANS_TOKEN_URL: 'https://api.sandbox.midtrans.com/v2/token',
  FIREBASE: {
    apiKey: 'AIzaSyB5RZ-k9Fd8RVCMJRbmOHK_32fwVWhHpIA',
    authDomain: 'f1-bullseye.firebaseapp.com',
    databaseURL: 'https://f1-bullseye.firebaseio.com',
    projectId: 'f1-bullseye',
    storageBucket: 'f1-bullseye.appspot.com',
    messagingSenderId: '588138102088',
    appId: '1:588138102088:web:57eea37640c43756'
  },
  GOOGLE_MAPS_API_URL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB5RZ-k9Fd8RVCMJRbmOHK_32fwVWhHpIA&v=3.exp&libraries=geometry,drawing,places&region=ID&language=id'
};
export default development;